import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from '@mui/material';

import { RetailerNetworkScanDataLatestSubmissionsFragment } from '@occc/graphql';

import { TobaccoSubmissionsTable } from './tobacco-submissions-table.component';

import { routeCreator } from '../../../retailer-connect.utils';
import { TobaccoStoresSubmissionsTableContainer } from '../../../retailer-network-tobacco-scan-data-page/components/tobacco-stores-submissions-table/tobacco-stores-submissions-table.container';
import { useRetailerNetworkScanDataTobaccoLatestSubmissions } from '../../../hooks/use-retailer-network-scan-data-tobacco-latest-submissions.hook';

type TobaccoSubmissionsTableContainerProps = {
  retailerNetworkUuid: string;
};

export const TobaccoSubmissionsTableContainer = ({
  retailerNetworkUuid,
}: TobaccoSubmissionsTableContainerProps) => {
  const navigate = useNavigate();
  const [storesSubmissionsDate, setStoresSubmissionsDate] = React.useState<Date | undefined>();

  const { data, loading, error } = useRetailerNetworkScanDataTobaccoLatestSubmissions({
    retailerNetworkUuidEquals: retailerNetworkUuid,
  });

  const onViewAllSubmissionsClick = useCallback(() => {
    navigate(routeCreator.tobaccoScanData(retailerNetworkUuid));
  }, [navigate, retailerNetworkUuid]);

  const onViewAllStores = useCallback(
    (submission: RetailerNetworkScanDataLatestSubmissionsFragment) => {
      setStoresSubmissionsDate(new Date(submission.submittedAt));
    },
    [],
  );

  return (
    <>
      <TobaccoSubmissionsTable
        data={data}
        onViewAllSubmissionsClick={onViewAllSubmissionsClick}
        onViewAllStoresClick={onViewAllStores}
        loading={loading}
        error={error}
      />
      <Dialog
        open={!!storesSubmissionsDate}
        onClose={() => setStoresSubmissionsDate(undefined)}
        maxWidth='md'
        fullWidth
      >
        {storesSubmissionsDate && (
          <TobaccoStoresSubmissionsTableContainer
            submittedAt={storesSubmissionsDate}
            retailerNetworkUuid={retailerNetworkUuid}
          />
        )}
      </Dialog>
    </>
  );
};
